module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-3-694e3323586b616ef0b9888b2943fc54.jpg";